import React from "react"

import FooterSectionDesktop from "./FooterSectionDesktop"
import FooterSectionMobile from "./FooterSectionMobile"

const FooterSection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <FooterSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  if (viewMode === "desktop") {
    return (
      <FooterSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <FooterSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Default to desktop for desktop devices
  return (
    <FooterSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  )
}

export default FooterSection
